// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarLayout_container__4nk9K","sidebar":"SidebarLayout_sidebar__111MS","fixed_container":"SidebarLayout_fixed_container__30l4D"};